import { Send, Lock, GitBranchPlus } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

export const IssueButton = ({ q, disabled, onIssue }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <Button className="w-full bg-red-600 hover:bg-red-500 text-white font-semibold tracking-wide" disabled={disabled} data-testid="btn-send-quote">
        <Send className="h-4 w-4 mr-2" />INVIA PREVENTIVO
      </Button>
    </AlertDialogTrigger>
    <AlertDialogContent className="bg-slate-900 border-slate-700 w-[calc(100%-2rem)] rounded-lg">
      <AlertDialogHeader>
        <AlertDialogTitle>Inviare il preventivo?</AlertDialogTitle>
        <AlertDialogDescription>
          {q.number ? `Il preventivo ${q.code} verrà inviato` : "Il preventivo riceverà il numero progressivo"}: verrà salvato il PDF e non sarà più modificabile.
          Per cambiarlo dopo dovrai creare una revisione.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="issue-cancel">Annulla</AlertDialogCancel>
        <AlertDialogAction onClick={onIssue} className="bg-red-600 hover:bg-red-700 text-white" data-testid="issue-confirm">Sì, invia</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const LockedBanner = ({ q, onRevision, busy }) => (
  <div className="flex flex-wrap items-center gap-3 rounded-lg border border-sky-500/40 bg-sky-500/10 px-4 py-3" data-testid="quote-locked-banner">
    <Lock className="h-4 w-4 text-sky-300" />
    <p className="text-sm text-sky-100 flex-1 min-w-[200px]">
      Preventivo <b className="font-mono">{q.code}</b> inviato{q.issued_at ? ` il ${new Date(q.issued_at).toLocaleDateString("it-IT")}` : ""}: non è più modificabile.
    </p>
    <Button onClick={onRevision} disabled={busy} className="bg-sky-600 hover:bg-sky-500 text-white" data-testid="btn-create-revision">
      <GitBranchPlus className="h-4 w-4 mr-2" />Crea revisione
    </Button>
  </div>
);
